document.addEventListener('DOMContentLoaded', initNutritionTables);
document.addEventListener('shopify:section:load', initNutritionTables);

function initNutritionTables() {
  const richTextFields = document.querySelectorAll('.metafield-rich_text_field');

  richTextFields.forEach((field) => {
    if (field.dataset.nutritionConverted === 'true') return;

    const paragraphs = field.querySelectorAll('p');

    if (paragraphs.length < 2) return;

    const heading = paragraphs[0].textContent.trim();

    if (!heading.toLowerCase().includes('nährwerte')) return;

    const contentParagraph = paragraphs[1];

    const lines = contentParagraph.innerHTML
      .split(/<br\s*\/?>/gi)
      .map((line) => {
        const temp = document.createElement('div');
        temp.innerHTML = line;

        return temp.textContent
          .replace(/\u00A0/g, ' ')
          .trim();
      })
      .filter(Boolean);

    if (!lines.length) return;

    const table = document.createElement('div');
    table.className = 'nutrition-table';

    const header = document.createElement('div');
    header.className = 'nutrition-table__header';

    const headerTitle = document.createElement('div');
    headerTitle.className = 'nutrition-table__header-title';
    headerTitle.textContent = heading;

    header.appendChild(headerTitle);
    table.appendChild(header);

    lines.forEach((line) => {
      const separatorIndex = line.indexOf(':');

      if (separatorIndex === -1) return;

      const label = line.substring(0, separatorIndex).trim();
      const value = line.substring(separatorIndex + 1).trim();

      const row = document.createElement('div');
      row.className = 'nutrition-table__row';

      if (label.toLowerCase().startsWith('davon ')) {
        row.classList.add('nutrition-table__row--sub');
      }

      const labelCell = document.createElement('div');
      labelCell.className = 'nutrition-table__label';
      labelCell.textContent = label;

      const valueCell = document.createElement('div');
      valueCell.className = 'nutrition-table__value';
      valueCell.textContent = value;

      row.appendChild(labelCell);
      row.appendChild(valueCell);

      table.appendChild(row);
    });

    field.innerHTML = '';
    field.appendChild(table);

    field.dataset.nutritionConverted = 'true';
  });
}